const ReadingComprehensionSvg = () => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_18087_164652)">
      <path
        d="M27.6471 6.88321H25.9809V5.62941C25.9809 5.39575 25.8415 5.18466 25.6266 5.09289C22.1077 3.59074 17.7783 4.22739 14.2304 6.74375C10.6827 4.22739 6.35313 3.59092 2.83434 5.09289C2.6194 5.18466 2.48 5.39575 2.48 5.62941V6.88321H0.813793C0.491679 6.88321 0.230469 7.14436 0.230469 7.46654V23.5901C0.230469 23.9123 0.491679 24.1734 0.813793 24.1734H14.2305H27.6471C27.9693 24.1734 28.2305 23.9122 28.2305 23.5901V7.4666C28.2305 7.14442 27.9693 6.88321 27.6471 6.88321ZM1.39712 23.0068V8.04992H2.48V21.753C2.48 21.9489 2.5784 22.1317 2.74186 22.2397C2.90537 22.3477 3.11208 22.3663 3.2923 22.2894C6.02467 21.123 9.32437 21.4147 12.2531 23.0068H1.39712ZM13.6472 22.4747C11.5182 21.118 9.14984 20.4136 6.86376 20.4136C5.76009 20.4136 4.67573 20.5778 3.6467 20.912V7.47335C3.6467 7.47104 3.64706 7.46885 3.64706 7.4666C3.64706 7.46435 3.64676 7.46209 3.6467 7.45984V6.02399C6.75807 4.85781 10.5308 5.50998 13.6472 7.76075V22.4747ZM14.8138 7.76075C17.9302 5.50992 21.7031 4.85781 24.8143 6.02399V7.45978C24.8143 7.46204 24.8139 7.46429 24.8139 7.46654C24.8139 7.46879 24.8142 7.47104 24.8143 7.47329V20.9119C21.6537 19.8853 17.9706 20.4631 14.8138 22.4747V7.76075ZM27.0638 23.0068H16.2078C19.1366 21.4147 22.4362 21.1231 25.1686 22.2894C25.3489 22.3664 25.5557 22.3477 25.7191 22.2397C25.8826 22.1317 25.9809 21.9489 25.9809 21.753V8.04992H27.0638V23.0068Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_18087_164652">
        <rect
          width="28"
          height="28"
          fill="white"
          transform="translate(0.230469 0.231934)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ReadingComprehensionSvg;
